// components/cnt-list/component
/* global DEBUG */

import template  from './component.jade'
import table     from './table.jade'
import Store     from 'Store'

import parseTime from 'lib/filters/parseUnixTime'
import parseLink from 'lib/filters/parseCntLink'
import parseAutoExpCntLink from 'lib/filters/parseAutoExpCntLink'
import parseOrderLink from 'lib/filters/parseOrderLink'
import parseTransportType from 'lib/filters/parseTransportType'
import parseStock from 'lib/filters/parseStock'
import onClick   from 'lib/methods/onClick'
import style from './style.scss'

let name = 'cnt-list';
let url = '/api/CntList'
const store = new Store(name);
const allowedLogins = [
    'admin',
    'TesDV1',
    'TesDV2',
    'TesDV3',
    'TesDV4',
    'Transit1',
    'Transit2',
    'Transit3',
    'Transit4',
    'CubeLog1',
    'AltLog1',
];

let tableSortExpense =function (a, b) {
    if (a.date_in > b.date_in)
        return -1;
    if (a.date_in < b.date_in)
        return 1;
    return 0;
};
let tableSortBalance =function (a, b) {
    if (a.date_out > b.date_out)
        return -1;
    if (a.date_out < b.date_out)
        return 1;
    return 0;
};

// вспомогательный компонент
// разделяет таблицу на 2 таблицы
var tableView = {
  name: name + '-table',
  template: table({
      style: style
  }),
  props: ['title', 'table', 'dateOutShow', 'columnSort', 'reverse'],
  mixins: [parseTime, parseLink, parseStock, onClick, parseAutoExpCntLink, parseOrderLink, parseTransportType ],
  data: ()=>({
      sortClass: {
          date_in:true,
          date_out:true,
          number:true,
          konos:true,
          cnt_date_close:true,
      },
      sortShowArrow: {
          date_in:false,
          date_out:false,
          number:false,
          konos:false,
          cnt_date_close:false,
      },


  }),
  ready(){
   this.sortTable(this.dateOutShow ? 'date_out': 'date_in');
   this.sortShowArrow[this.dateOutShow ? 'date_out': 'date_in'] = true;
  },
   methods:{
       sortTable(column) {
           if (this.sortClass[column]){
               this.table.sort(function (a, b) {
                   if (typeof a[column] === 'string'){
                       let numberA=a[column].toLowerCase(), numberB=b[column].toLowerCase();
                       if (numberA < numberB) //sort string ascending
                           return 1;
                       if (numberA > numberB)
                           return -1;
                       return 0
                   }
                   if (typeof a[column] === 'number'){
                       return b[column] - a[column]
                   }
               });
               this.sortClass[column] = !this.sortClass[column];
               for (let prop in this.sortShowArrow) {
                   if( this.sortShowArrow.hasOwnProperty( prop ) ) {
                       this.sortShowArrow[prop] = (prop === column);
                   }
               }
           } else {
               this.table.sort(function (a, b) {
                   if (typeof a[column] === 'string'){
                       let numberA=a[column].toLowerCase(), numberB=b[column].toLowerCase();
                       if (numberA < numberB) //sort string descending
                           return -1;
                       if (numberA > numberB)
                           return 1;
                       return 0
                   }
                   if (typeof a[column] === 'number') {
                       return a[column] - b[column]
                   }
               });
               this.sortClass[column] = !this.sortClass[column];
               for (let prop in this.sortShowArrow) {
                   if (this.sortShowArrow.hasOwnProperty(prop)) {
                       this.sortShowArrow[prop] = (prop === column);
                   }
               }
           }
       },
   }
}

export default {

  name: name,
  template: template(),
  props: ['table'],

  data: () => ({
    name: name,
    url: url,
    data: {},
  //  showCloseStoreButton: false,
  }),
 ready(){
/*         let check;
         check = allowedLogins.indexOf(store.$get('login'));
         this.showCloseStoreButton = check >= 0;*/
 },
  events: {
    // при изменении дат, запросим список счетов
    ['dates:' + name]: function (data) {
      //DEBUG && console.log('dates:' + name, data)
      var {number: number} = data;
      this.$set('title', number);
      this.$set('current', number);
      this.$set('data', null);
      this.$set('data', data);
      this.$set('data', store.$get(this));
    },

    // при изменении строки поиска, запросим счет
    ['number:' + name]: function (data) {
      //DEBUG && console.log('number:' + name, data)

      data.name = 'cnt-info'
      this.$dispatch('number', data)
    },
  },
 methods:{
     searchContainerInTable(numberContainer){
         let number = numberContainer.trim().toLowerCase();
         if (number.length === 0){
             this.data.table = this.data.tableCopy;
         } else {
             this.data.table = this.data.tableCopy.filter((container)=>{
                 return container.number.toLowerCase().indexOf(number) !== -1
             });
         }
         return this.data.table.length;
     }
 },
  computed: {
    tables() {
      //DEBUG && console.log('computed:tables')
      var tables = {
        expense: [],
        balance: [],
      }
      if (this.data.tableCopy === undefined){
          this.data.tableCopy = this.data.table;
      }
      this.data.table.forEach( (row, index, table) => {
        if (row.date_out) {
          tables.balance.push(row)
        } else {
          tables.expense.push(row)
        }
      })
        tables.expense.sort(tableSortExpense);
        tables.balance.sort(tableSortBalance);
      return tables
    },
  },


  components: {
    [tableView.name]: tableView,
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/cnt-list/component.js
 **/